export const DOWNSAMPLE = "Downsample";
export const TRUNCATE = "Truncate";
export const ZEROBELOWTHRESHOLD = "ZeroBelowThreshold";
export const SMOOTHFILTER = "SmoothFilter";
